module.exports = __webpack_public_path__ + "static/Group-3be6883da9dddacc1ddb916bf43e9b55.png";